import exportPdf from './exportPdf'

const lia = {
  exportPdf,
}

export default lia
